export default class SelectContent {
	constructor() {
		this.$select = $('.js-select-content-select');
		this.$content = $('.js-select-tab-content');
		this.$replaceContent = $('.js-select-content-replace-active');
		this.activeClass = 'active';

		this.initialize();
	}

	_initalizeSelect2() {
		this.$select.select2();
	}

	_setActiveContent(select) {
		const that = this;

		const value = parseInt(select.find('option:selected').val());

		this.$content.each(function () {
			let $content = $(this);

			$content.removeClass(that.activeClass);

			if ($content.data('select-content-id') === value) {
				$content.addClass(that.activeClass);
			}
		});
	}

	_setActiveContentAfterChange() {
		const that = this;

		this.$select.on('change', function () {
			that._setActiveContent($(this));

			that._setReadableContent();
		});
	}

	_setActiveContentOnInit() {
		this._setActiveContent(
			this.$select
		)
	}

	_setReadableContent() {
		if (this.$replaceContent.length) {
			this.$replaceContent.text(
				this.$select.find('option:selected').text()
			);
		}
	}

	initialize() {
		this._initalizeSelect2();
		this._setActiveContentOnInit();
		this._setActiveContentAfterChange();
		this._setReadableContent();
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/selectContent.js